import { useParams } from "react-router-dom";
import EditManageReferralReq from "./EditManageReferralReq";
import { useGetRefReqByIdQuery } from "../../../../../reactQueries/AppApi/rqHooksForReferrals";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";

const EditManageReferralReqHome = () => {
  let { Id } = useParams();
  const {
    isSuccess,
    isFetching,
    error,
    data: dataById,
    isError,
    isFetched,
  } = useGetRefReqByIdQuery({ Id });

  return (
    <div>
      {(!!isFetching) && "Wait, Loading..."}

      {!!isSuccess && <EditManageReferralReq dataById={dataById} />}

      <MpgErrorDialog
        open={!!isError}
      />
    </div>
  );
};
export default EditManageReferralReqHome;
